<template>
    <input type="number" v-model="newAmount" step="1" max="5000" @blur="checkAmount" v-on:keyup="amountChange"/>
</template>
<script>
    export default {
      data () {
        return {
          newAmount: null
        }
      },
      props: ['amount'],
      created: function () {
        this.newAmount = this.amount
      },
      methods: {
        amountChange () {
          if (this.newAmount.length) {
            this.newAmount = (this.newAmount + '').replace(/\D+/g, '') * 1
            if (this.newAmount >= 5000) {
              this.newAmount = 5000
              this.$emit('changedAmount', this.newAmount)
            } else {
              this.$emit('changedAmount', this.newAmount)
            }
          } else {
            this.$emit('changedAmount', null)
          }
        },
        checkAmount () {
          // if (!this.newAmount) {
          //   this.newAmount = 1
          //   this.$emit('changedAmount', this.newAmount)
          // } else {
          // }
        }
      }
    }
</script>
<style scoped>
  input {

  }
</style>



// WEBPACK FOOTER //
// src/components/inputComponent.vue